import { render, staticRenderFns } from "./WorkSheet.vue?vue&type=template&id=5479160e&scoped=true"
import script from "./WorkSheet.vue?vue&type=script&lang=js"
export * from "./WorkSheet.vue?vue&type=script&lang=js"
import style0 from "./WorkSheet.vue?vue&type=style&index=0&id=5479160e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479160e",
  null
  
)

export default component.exports